import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import {GlobalsService} from '../_services/globals.service'; 

export interface SearchResult {
  naslov: string;
  _na_mid: number;
  _hs_mid: number;
  lon: number;
  lat: number;
  obcina?: string;
}

@Injectable({ providedIn: 'root' })
export class SearchService {
  private bhsSrchResultSelect = new Subject<any>();
  private bhsSrchResultUnSelect = new Subject<void>();

  private srchResultSelectObservable = this.bhsSrchResultSelect.asObservable();
  private srchResultUnSelectObservable = this.bhsSrchResultUnSelect.asObservable();

  private get API(): string {
    return GlobalsService.getTypesenseApiUrl();
  }

  constructor(private http: HttpClient) {}

  public findAddress(
    keywords: string,
    maxResults: number = 100,
    obMid?: number
  ): Observable<SearchResult[]> {
    let params = new HttpParams()
      .set('keywords', keywords.trim())
      .set('maxResults', String(maxResults));

    if (obMid != null) {
      params = params.set('ob_mid', String(obMid));
    }

    return this.http.get<SearchResult[]>(`${this.API}/search`, { params });
  }

  public findKoIdStId(
    koId: number,
    stId: number,
    maxResults: number = 100,
    obMid?: number
  ): Observable<SearchResult[]> {
    let params = new HttpParams()
      .set('ko_id', String(koId))
      .set('st_id', String(stId))
      .set('maxResults', String(maxResults));

    if (obMid != null) {
      params = params.set('ob_mid', String(obMid));
    }

    return this.http.get<SearchResult[]>(`${this.API}/search`, { params });
  }

  public setSelectedResult(f: any): void {
    this.bhsSrchResultSelect.next(f);
  }

  public subscribeSelectedResultListener(): Observable<any> {
    return this.srchResultSelectObservable;
  }

  public setUnselectResult(): void {
    this.bhsSrchResultUnSelect.next();
  }

  public subscribeUnSelectedResultListener(): Observable<void> {
    return this.srchResultUnSelectObservable;
  }
}